export default {
    state: {
      promo: {
        show: false,
        refreshID: null,
        list: []
      }
    },
    mutations: {
      setGeofencePromoShow (state, value) {
        state.promo.show = value
        state.promo.refreshID = null
      },
      setGeofencePromoList (state, value) { state.promo.list = value },
      setGeofencePromoRefreshID (state, value) { state.promo.refreshID = value }
    }
  }
  


// WEBPACK FOOTER //
// ./src/store/pricing/promo.js